import {Action} from '@ngrx/store';
import {type} from '../../shared';

export const conceptLoadActionTypes = {
  Load: type('[Concept] Load'),
  Load_SUCCESS: type('[Concept] Load Success'),
  Load_FAIL: type('[Concept] Load Fail'),
};

export class LoadConceptAction implements Action {
  readonly type = conceptLoadActionTypes.Load;
  // tslint:disable-next-line:no-any
  constructor(public payload?:  any) {}
}

export class LoadConceptSuccessAction implements Action {
  readonly type = conceptLoadActionTypes.Load_SUCCESS;
  // tslint:disable-next-line:no-any
  constructor(public payload?: any) {}
}

export class LoadConceptFailAction implements Action {
  readonly type = conceptLoadActionTypes.Load_FAIL;
  constructor(public payload?: string) {}
}
